import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=5e07ca4c&scoped=true"
import script from "./Guardian.vue?vue&type=script&lang=js"
export * from "./Guardian.vue?vue&type=script&lang=js"
import style0 from "./Guardian.vue?vue&type=style&index=0&id=5e07ca4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07ca4c",
  null
  
)

export default component.exports